import Vue from 'vue'
import Vuex from 'vuex'
import VueResource from 'vue-resource'

import lodash from 'lodash'
import VueLodash from 'vue-lodash/dist/vue-lodash.min'

Vue.use(VueLodash, lodash)

import vuexI18n from 'vuex-i18n'
import * as catalan from '../translations/ca.json'
import * as english from '../translations/en.json'
import * as spanish from '../translations/es.json'

import api from './api'

import auth from './modules/auth'
import nv from './modules/nv'
import ad from './modules/ad/ad'
import ad_municipalities from './modules/ad/ad_municipalities'
import appraisalfiles from './modules/appraisalfiles'
import appraiser from './modules/appraiser/appraiser'
import supervisor from './modules/supervisor/supervisor'
import realestate from './modules/realestate/realestate'
import appraisal from './modules/appraisal/appraisal'
import appraisal_bec_prices from './modules/appraisal/appraisal_bec_prices'
import appraisal_bec_properties from './modules/appraisal/appraisal_bec_properties'
import appraisal_rooms from './modules/appraisal/appraisal_rooms'
import appraisal_covered_outdoors from './modules/appraisal/appraisal_covered_outdoors'
import appraisal_uncovered_outdoors from './modules/appraisal/appraisal_uncovered_outdoors'
import appraisal_constraints from './modules/appraisal/appraisal_constraints'
import appraisal_warnings from './modules/appraisal/appraisal_warnings'
import appraisal_notes from './modules/appraisal/appraisal_notes'
import appraisal_photographs from './modules/appraisal/appraisal_photographs'
import appraisal_registryannexes from './modules/appraisal/appraisal_registryannexes'
import appraisal_cadasterannexes from './modules/appraisal/appraisal_cadasterannexes'
import appraisal_urbanannexes from './modules/appraisal/appraisal_urbanannexes'
import appraisal_planannexes from './modules/appraisal/appraisal_planannexes'
import appraisal_cessionannexes from './modules/appraisal/appraisal_cessionannexes'
import appraisal_otherannexes from './modules/appraisal/appraisal_otherannexes'
import emailaddress from './modules/emailaddress/emailaddress'
import telephonenumber from './modules/telephonenumber/telephonenumber'
import realestate_appraisals from './modules/realestate/realestate_appraisals'
import realestate_marketstudies from './modules/realestate/realestate_marketstudies'
import realestate_municipalities from './modules/realestate/realestate_municipalities'
import realestate_projects from './modules/realestate/realestate_projects'
import comparable from './modules/ad_comparable/ad_comparable'
import contact from './modules/contact/contact'
import appraisalfile from './modules/appraisalfile/appraisalfile'
import appraisalfile_appraisalreports from './modules/appraisalfile/appraisalfile_appraisalreports'
import appraisalreport from './modules/appraisalreport/appraisalreport'
import appraisalreport_realestates from './modules/appraisalreport/appraisalreport_realestates'
import appraisalreport_petitioners from './modules/appraisalreport/appraisalreport_petitioners'
import appraisalfile_appraisalquotes from './modules/appraisalfile/appraisalfile_appraisalquotes'
import appraisalquote from './modules/appraisalquote/appraisalquote'
import appraisalquote_petitioners from './modules/appraisalquote/appraisalquote_petitioners'
import appraisalquote_realestates from './modules/appraisalquote/appraisalquote_realestates'
import appraisalquote_requireddocs from './modules/appraisalquote/appraisalquote_requireddocs'

import appraisalfile_appraisalinvoices from './modules/appraisalfile/appraisalfile_appraisalinvoices'
import appraisalinvoice from './modules/appraisalinvoice/appraisalinvoice'
import appraisalinvoice_lines from './modules/appraisalinvoice/appraisalinvoice_lines'
import appraisalinvoice_petitioners from './modules/appraisalinvoice/appraisalinvoice_petitioners'
import appraisalinvoice_appraisalquotes from './modules/appraisalinvoice/appraisalinvoice_appraisalquotes'

import becprice from './modules/becprice/becprice'
import becproperty from './modules/becproperty/becproperty'
import becproperty_becprices from './modules/becproperty/becproperty_becprices'
import contact_addresses from './modules/contact/contact_addresses'
import contact_emailaddresses from './modules/contact/contact_emailaddresses'
import contact_telephonenumbers from './modules/contact/contact_telephonenumbers'
import contact_appraisalinvoices from './modules/contact/contact_appraisalinvoices'
import contact_appraisalquotes from './modules/contact/contact_appraisalquotes'
import contact_appraisalreports from './modules/contact/contact_appraisalreports'
import entity from './modules/entity/entity'
import marketstudy from './modules/marketstudy/marketstudy'
import marketstudy_ads from './modules/marketstudy/marketstudy_ads'
import marketstudy_ad_comparables from './modules/marketstudy/marketstudy_ad_comparables'
import room from './modules/room/room'
import line from './modules/line/line'
import covered_outdoor from './modules/covered_outdoor/covered_outdoor'
import uncovered_outdoor from './modules/uncovered_outdoor/uncovered_outdoor'
import constraint from './modules/constraint/constraint'
import warning from './modules/warning/warning'
import note from './modules/note/note'
import photograph from './modules/photograph/photograph'
import project from './modules/project/project'
import registryannex from './modules/registryannex/registryannex'
import cadasterannex from './modules/cadasterannex/cadasterannex'
import urbanannex from './modules/urbanannex/urbanannex'
import planannex from './modules/planannex/planannex'
import cessionannex from './modules/cessionannex/cessionannex'
import otherannex from './modules/otherannex/otherannex'

import { getNotesForUserId } from './api'

import {
    SET_ACTIVE_CONTACT,
    SET_ACTIVE_NOTE,
    SET_ACTIVE_KEY,
    SET_QUERY,
    SET_LANGUAGE,
    SET_THEME,
    SET_NOTES,
    SET_RESULT_INDEX,
    SET_RENAMING_ID,
    SET_EDITING_ID
} from './constants'


Vue.use(VueResource)
Vue.use(Vuex)



const store = new Vuex.Store({
    state: {
        query: '',
        resultIndex: -1,
        renamingId: null,
        editingId: null
    },

    modules: {
        auth,
        ad,
        ad_municipalities,
        appraisal,
        appraisal_bec_prices,
        appraisal_bec_properties,
        appraisal_rooms,
        appraisal_covered_outdoors,
        appraisal_uncovered_outdoors,
        appraisal_constraints,
        appraisal_warnings,
        appraisal_notes,
        appraisal_photographs,
        appraisal_registryannexes,
        appraisal_cadasterannexes,
        appraisal_urbanannexes,
        appraisal_planannexes,
        appraisal_cessionannexes,
        appraisal_otherannexes,
        appraisalfile,
        appraisalfile_appraisalreports,
        appraisalfile_appraisalquotes,
        appraisalfile_appraisalinvoices,
        appraisalfiles,
        appraisalreport,
        appraisalquote,
        appraisalinvoice,
        appraiser,
        supervisor,
        becprice,
        becproperty,
        becproperty_becprices,
        comparable,
        contact,
        appraisalreport_realestates,
        appraisalreport_petitioners,
        appraisalquote_petitioners,
        appraisalquote_realestates,
        appraisalquote_requireddocs,
        appraisalinvoice_lines,
        appraisalinvoice_appraisalquotes,
        appraisalinvoice_petitioners,
        contact_addresses,
        contact_emailaddresses,
        contact_telephonenumbers,
        contact_appraisalinvoices,
        contact_appraisalquotes,
        contact_appraisalreports,
        emailaddress,
        entity,
        marketstudy,
        marketstudy_ads,
        marketstudy_ad_comparables,
        realestate,
        realestate_appraisals,
        realestate_marketstudies,
        realestate_municipalities,
        realestate_projects,
        room,
        line,
        covered_outdoor,
        uncovered_outdoor,
        telephonenumber,
        nv,
        constraint,
        warning,
        note,
        photograph,
        project,
        registryannex,
        cadasterannex,
        urbanannex,
        planannex,
        cessionannex,
        otherannex
    },

    actions: {
        RESET_ACTIVE_CONTACT: ({state, commit, rootState}) => {
            commit(SET_RESULT_INDEX, -1)
            commit(SET_ACTIVE_CONTACT, null)
            commit(SET_ACTIVE_KEY, null)
        },
        RESET_ACTIVE_NOTE: ({state, commit, rootState}) => {
            commit(SET_RESULT_INDEX, -1)
            commit(SET_ACTIVE_NOTE, null)
            commit(SET_ACTIVE_KEY, null)
        },
        RESET_APP: ({state, commit, rootState}) => {
            commit(SET_LANGUAGE, 'es' )
            commit(SET_THEME, 'light')
            commit(SET_QUERY, '')
            commit(SET_RESULT_INDEX, -1)
            commit(SET_NOTES, [])
            commit(SET_ACTIVE_NOTE, null)
            commit(SET_ACTIVE_KEY, null)
        },
        SET_VALUE: ({state, commit, rootState}, data) => {
            return new Promise((resolve, reject) => {
                api.set_value({
                    value: data.object,
                    path: data.path,
                    save_timestamp: false
                }).then(res => resolve({}))
            })
        },
        DELETE: ({state, commit, rootState}, data) => {
            return new Promise((resolve, reject) => {

                console.log('delete path: ' + data.path)
                api.delete({key: data.key, path: data.path})
                    .then((res) => {
                        resolve({})

                    })
            })
        },
    },

    mutations: {
        [SET_QUERY] (state, query) {
            state.query = query
        },

        [SET_RESULT_INDEX] (state, resultIndex) {
            state.resultIndex = resultIndex
        },

        [SET_RENAMING_ID] (state, renamingId) {
            state.renamingId = renamingId
        },

        [SET_EDITING_ID] (state, editingId) {
            state.editingId = editingId
        }
    },

    getters: {
        query: state => {
            return state.query
        },

        resultIndex: state => {
            return state.resultIndex
        },

        renamingId: state => {
            return state.renamingId
        },

        editingId: state => {
            return state.editingId
        },

        currentLocale: state => {
            return state.i18n.locale
        }
    }
})

Vue.use(vuexI18n.plugin, store)

Vue.i18n.add('ca', catalan)
Vue.i18n.add('en', english)
Vue.i18n.add('es', spanish)

let userLang = navigator.language || navigator.userLanguage

console.log('userLang: ')
console.log(userLang)

if (userLang === 'ca' || userLang === 'ca-ES') {
    Vue.i18n.set('ca')
} else if (userLang === 'es' || userLang === 'es-ES') {
    Vue.i18n.set('es')
} else if (userLang === 'en' || userLang === 'en-GB' || userLang === 'en-US') {
    Vue.i18n.set('en')
} else {
    Vue.i18n.set('es')
}

export default store



// WEBPACK FOOTER //
// ./src/store/index.js